import { Component, Input } from '@angular/core';
import { NgbOffcanvas } from '@ng-bootstrap/ng-bootstrap';
import { Driver } from '../interface/operational-staff.model';
import { EventEmitter, Output } from '@angular/core';

@Component({
  selector: 'app-add-personal-modal',
  templateUrl: './add-personal-modal.component.html',
  styleUrls: ['./add-personal-modal.component.css'],
})
export class AddPersonalModalComponent {
  @Input() driverInfo!: Driver;
  @Output() driverUpdated = new EventEmitter<void>();

  constructor(private offcanvasService: NgbOffcanvas) {
  }

  closeCanvas() {
    this.offcanvasService.dismiss();
  }

  onDriverUpdated(): void {
    this.driverUpdated.emit();
  }
}
